import * as mousetrap from 'mousetrap';
import React, { useState, useEffect } from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Shortcut = (props) => {
    const [altButtonPressed, setAltButtonPressed] = useState(false);
    const onDown = (event) => {
        if ([18].includes(event.keyCode))
            setAltButtonPressed(true);
    };
    const onUp = (event) => {
        if ([18].includes(event.keyCode))
            setAltButtonPressed(false);
    };
    const onBlur = (event) => setAltButtonPressed(false);
    useEffect(() => {
        getCombinations().map((combs) => mousetrap.bind(combs, props.onPress));
        document.addEventListener('keydown', onDown);
        document.addEventListener('keyup', onUp);
        window.addEventListener('blur', onBlur);
        return () => {
            getCombinations().map((combs) => mousetrap.unbind(combs));
            document.removeEventListener('keydown', onDown);
            document.removeEventListener('keyup', onUp);
            window.removeEventListener('blur', onBlur);
        };
    }, []);
    const getCombinations = () => {
        if (window.navigator.platform === 'MacIntel') {
            return [
                props.keys
                    .map((k) => (k.toLocaleLowerCase() === 'ctrl' ? 'command' : k))
                    .join('+'),
            ];
        }
        else {
            return [
                props.keys
                    .map((k) => (k.toLocaleLowerCase() === 'command' ? 'ctrl' : k))
                    .join('+'),
            ];
        }
    };
    if (!altButtonPressed)
        return null;
    return (React.createElement("div", { style: { position: 'relative', zIndex: 9999, ...props.style } },
        React.createElement(ShortCutTip, null, getCombinations().join(', '))));
};
export default Shortcut;
const ShortCutTip = styled.div `
  position: absolute;
  background-color: #000000;
  color: ${THEME.COLOR_SECONDARY};
  border-radius: 3px;
  padding: 3px 17px;
  font-size: 0.8em;
`;
//# sourceMappingURL=Shortcut.js.map